import { render, staticRenderFns } from "./account-verification-section.vue?vue&type=template&id=2f83f5fe&scoped=true&lang=pug&"
import script from "./account-verification-section.vue?vue&type=script&lang=ts&"
export * from "./account-verification-section.vue?vue&type=script&lang=ts&"
import style0 from "./account-verification-section.vue?vue&type=style&index=0&id=2f83f5fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f83f5fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VImg,VProgressCircular})
